import FormProv from './FormProv/FormProv'
import FormTrab from './FormTrab/FormTrab';
import FormDir from './FormDir/FormDir';
export const FormProvPage = FormProv
export const FormTrabPage = FormTrab
export const FormDirPage = FormDir
